import React from 'react';
import { useForm } from '../../context/FormContext';

const LICENCE_TYPES = [
  'Full UK',
  'Provisional UK',
  'European',
  'International',
  'No Licence'
];

export const DrivingLicenceStep = ({ onAutoAdvance }) => {
  const { formData, updateFormData } = useForm();

  const handleSelect = (type) => {
    updateFormData({ driving_licence_type: type });
    setTimeout(() => onAutoAdvance?.(), 300);
  };

  return (
    <div className="space-y-6" data-testid="driving-licence-step">
      <div className="text-center">
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Driving Licence
        </h2>
        <p className="text-slate-600 hidden md:block">What kind do you have?</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {LICENCE_TYPES.map(type => (
          <button
            key={type}
            onClick={() => handleSelect(type)}
            className={`p-4 rounded-xl border-2 transition-all text-center ${
              formData.driving_licence_type === type
                ? 'brand-border brand-bg-light brand-text font-medium'
                : 'border-slate-200 hover:border-slate-300 text-slate-700'
            }`}
            data-testid={`licence-type-${type.toLowerCase().replace(/\s/g, '-')}`}
          >
            {type}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DrivingLicenceStep;
